import { Component, OnInit } from '@angular/core';
import { CommonFunctionService } from '../../../../services/Common/common-function.service';
import { RegisterUserService } from '../../../../services/registerUser/register-user.service';
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {
  content;
  MerchantLogo;
  PaygLogo;
  businessName:any;
  merchantKeyId:any;
  resellerno:any;
  username:any;

  constructor(private commonfunction: CommonFunctionService, private registerUserService: RegisterUserService) { 
    this.username = this.commonfunction.getUserName();
    this.merchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno = this.commonfunction.getUserMerchantData().ResellerId;
  }

  ngOnInit() {
    this.registerUserService.isValidMerchantKeyId(this.merchantKeyId, this.resellerno).subscribe(result => {
      this.businessName = result.CompanyName;
    });


    this.content=localStorage.getItem('MerchantLogo')
     
    if(this.content == null )
    {
      this.MerchantLogo= false;
      this.PaygLogo = true;
    }
    else{
      this.MerchantLogo= true;
      this.PaygLogo = false;
    }
  
  }
 
}
